import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  onRemove?: () => void;
  clearable?: boolean;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ children, onRemove, clearable = false, className = '' }) => {
  return (
    <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-700 text-white ${className}`}>
      <span>{children}</span>
      {(clearable || onRemove) && (
        <button
          onClick={onRemove}
          className="ml-1 text-gray-400 hover:text-white"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Badge;
